export default "__VITE_ASSET__3823361e__"